import { useTranslations } from "next-intl";

export function OrDivider() {
  const t = useTranslations("auth.common");
  return (
    <div className="flex items-center gap-3 text-[13px] text-ink-faint">
      <span className="h-px flex-1 bg-line" />
      <span className="lowercase">{t("or")}</span>
      <span className="h-px flex-1 bg-line" />
    </div>
  );
}
